__turbopack_context__.v({
  "backBtn": "_0Wkdrq_backBtn",
  "body": "_0Wkdrq_body",
  "btn": "_0Wkdrq_btn",
  "closeButton": "_0Wkdrq_closeButton",
  "desc": "_0Wkdrq_desc",
  "label": "_0Wkdrq_label",
  "missingData": "_0Wkdrq_missingData",
  "missingDataHeader": "_0Wkdrq_missingDataHeader",
  "modal": "_0Wkdrq_modal",
  "modalContent": "_0Wkdrq_modalContent",
  "plain": "_0Wkdrq_plain",
  "root": "_0Wkdrq_root",
  "row": "_0Wkdrq_row",
  "title": "_0Wkdrq_title",
});
